// =============================================
// File: src/services/orderService.js
// =============================================

import axiosInstance from "./axiosConfig";

const orderService = {
  // Get all orders with pagination and filters
  getOrders: async (params = {}) => {
    try {
      const response = await axiosInstance.get("/orders", { params });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get single order by ID
  getOrderById: async (id) => {
    try {
      const response = await axiosInstance.get(`/orders/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Create new order
  createOrder: async (orderData) => {
    try {
      const response = await axiosInstance.post("/orders", orderData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update order
  updateOrder: async (id, orderData) => {
    try {
      const response = await axiosInstance.patch(
        `/orders/${id}/status`,
        orderData
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update order status
  updateOrderStatus: async (id, status) => {
    try {
      const response = await axiosInstance.patch(`/orders/${id}/status`, {
        status,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update shipping details
  updateShippingDetails: async (id, shippingData) => {
    try {
      const response = await axiosInstance.patch(
        `/orders/${id}/shipping`,
        shippingData
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Cancel order
  cancelOrder: async (id, reason) => {
    try {
      const response = await axiosInstance.post(`/orders/${id}/cancel`, {
        reason,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get order tracking
  getOrderTracking: async (id) => {
    try {
      const response = await axiosInstance.get(`/orders/${id}/tracking`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Process payment for order
  processPayment: async (id, paymentData) => {
    try {
      const response = await axiosInstance.post(
        `/orders/${id}/payment`,
        paymentData
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Generate invoice
  generateInvoice: async (id) => {
    try {
      const response = await axiosInstance.get(`/orders/${id}/invoice`, {
        responseType: "blob",
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get order history for customer
  getCustomerOrders: async (customerId, params = {}) => {
    try {
      const response = await axiosInstance.get(
        `/customers/${customerId}/orders`,
        { params }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Bulk update order status
  bulkUpdateStatus: async (orderIds, status) => {
    try {
      const response = await axiosInstance.post("/orders/bulk-status", {
        orderIds,
        status,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default orderService;
